// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".professor-image-pos{width:calc(98px + 1vw);height:calc(96px + 1vw);border-radius:3px;background:#fff;border:none!important}.border-prof-img{width:calc(100px + 1vw);height:calc(100px + 1vw);border-radius:5px;border:none!important;padding:2px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
